import React from "react";
import { Accordion } from "react-bootstrap";

const Question = ({ eventKey, question, answer }) => {
  return (
    <Accordion.Item eventKey={eventKey}>
      <Accordion.Header>
        <i className="fa fa-question-circle"></i> {question}
      </Accordion.Header>
      <Accordion.Body>
        <p className="mb-0">{answer}</p>
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default Question;
